import { useEffect, useRef, useState } from "react";
import { AxiosInstance } from "../api/api";
import { useAuth } from "./auth";
import CustomModal from "../components/CustomModal/CustomModal";

const AxiosInterceptor = ({ children }) => {

    const { signOut } = useAuth();

    const isRunning = useRef(false);
    const showModalRef = useRef(false);
    const [showModal, setShowModal] = useState(false);
    const [shouldLogout, setShouldLogout] = useState(false);
    const [modalMessage, setModalMessage] = useState({
        Title: "",
        Message: "",
        SecondaryMessage: "",
    });

    // Mantener showModalRef sincronizado con showModal
    useEffect(() => {
        showModalRef.current = showModal;
    }, [showModal]);

    const toggleModal = ({ Title = "Error", Message, SecondaryMessage = "" }, shouldTriggerLogout = false) => {
        setModalMessage({ Title, Message, SecondaryMessage });
        setShouldLogout(shouldTriggerLogout);
        setShowModal(true);
    }
    
    const handleCloseModal = () => {
        setShowModal(false);
        
        // Si debe hacer logout, ejecutarlo después de cerrar
        if (shouldLogout) {
            setShouldLogout(false);
            // Pequeño delay para que el modal se cierre visualmente
            setTimeout(() => {
                signOut();
            }, 300);
        }
    }

    useEffect(() => {
        // if(isRunning.current) return;
        console.log("axios!!!")
        const resInterceptor = response => {
            // Verificar que response y data existen
            if (!response || !response.data) {
                return response;
            }

            const { data } = response;
            
            // Verificar si data es null o undefined
            if (data === null || data === undefined) {
                return response;
            }
            
            if (data.status === "error") {
                // activeModal({ "body": data.response.replace(/^\s+|\s+$/g, '') })
            }

            // Validación más robusta para evitar errores con null
            let parsedData = null;
            try {
                // Verificar que data[0] existe y tiene JSONData antes de intentar parsear
                if (!data || !Array.isArray(data) || !data[0] || !data[0].JSONData) {
                    return response;
                }
                
                // Solo parsear si JSONData no es null
                if (data[0].JSONData === null || data[0].JSONData === undefined) {
                    return response;
                }
                
                const parsed = JSON.parse(data[0].JSONData);
                parsedData = Array.isArray(parsed) ? parsed[0] : parsed;
                
            } catch (error) {
                console.log("Error parsing data:", error);
                return response;
            }

            // Verificar que parsedData no es null antes de acceder a sus propiedades
            if (parsedData && typeof parsedData === 'object') {

                if (parsedData?.Error) {
                    console.log("The response error ==== ", parsedData.Error)
                    console.log("The response error message ==== ", parsedData.Msg)
                    // Si hay Error, NO interceptar aquí, dejar que el componente maneje el error
                    // activeModal({ "body": parsedData.Msg })
                }
                
                // Solo interceptar Logout/Expired si NO hay Error
                // Si hay Error=true, el componente manejará tanto el error como el logout
                const hasError = parsedData?.Error === true;
                if (!hasError && (parsedData?.Expired || parsedData?.Logout || parsedData?.Msg === 'MsgSessionTokenNoExiste' || parsedData?.Msg === 'MsgSessionExpired')) {
                    
                    if(showModalRef.current) return response;
                    toggleModal({ 
                        "Title": "Sesión finalizada!", 
                        "Message": "Por motivos de seguridad la sesión ha sido finalizada.",
                        "SecondaryMessage": "Se requiere un nuevo inicio de sesión para continuar trabajando en el sistema!"
                    }, true) // true = ejecutar logout al cerrar modal
                }
            }
            return response;
        }

        const errResInterceptor = error => {
            // Evitar errores durante el logout
            if (!error) {
                return Promise.reject(error);
            }

            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log("❗ ~ file: axios.js:60 ~ errResInterceptor ~ error.response:", error.response)

                // Intentar parsear el error como JSON con Title y Message
                // Si tiene este formato, NO mostrar modal aquí (dejar que el componente lo maneje)
                let shouldShowModal = true;
                let parsedError = null;
                
                try {
                    // Intentar parsear si es string
                    if (typeof error.response.data === 'string') {
                        parsedError = JSON.parse(error.response.data);
                    } 
                    // O usar directamente si ya es objeto
                    else if (typeof error.response.data === 'object') {
                        parsedError = error.response.data;
                    }
                    
                    // Verificar si tiene Title y Message
                    if (parsedError && parsedError.Title && parsedError.Message) {
                        // Este error será manejado por el componente (LoginForm, etc)
                        console.log("✅ Error con Title/Message detectado, dejando que el componente lo maneje");
                        shouldShowModal = false;
                    }
                } catch (e) {
                    console.log("Error al parsear:", e);
                    // No es JSON o no tiene Title/Message, continuar con el flujo normal
                }

                // Solo mostrar el modal si NO es un error con Title/Message
                if (shouldShowModal) {
                    if(showModalRef.current) return Promise.reject(error);
                    
                    try {
                        const errorMessage = typeof error.response.data === 'string' 
                            ? error.response.data.replace(/[\r\n]/gm, '')
                            : 'Error en el servidor';
                        
                        toggleModal({ 
                            "Title": "Error de Servidor", 
                            "Message": errorMessage,
                            "SecondaryMessage": "" // Sin mensaje secundario para errores de servidor
                        }, false) // false = NO ejecutar logout al cerrar modal
                    } catch (e) {
                        console.log("Error al mostrar modal:", e);
                    }
                }
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log("❗ ~ file: axios.js:67 ~ errResInterceptor ~ error.request:", error.request)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log("❗ ~ file: axios.js:70 ~ errResInterceptor ~ error.message:", error.message)
              }
              console.log(error.config);
            return Promise.reject(error)
        }

        const interceptor = AxiosInstance.interceptors.response.use(resInterceptor, errResInterceptor, { synchronous: true })

        isRunning.current = true

        return () => {
            console.log("axios closed!!!")
            AxiosInstance.interceptors.response.eject(interceptor);
        }
    }, [])


    const ErrorModal = () => {
        if (!showModal) return null;

        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            }}>
                <CustomModal
                    type="errorMessageBD"
                    title={modalMessage.Title}
                    message={modalMessage.Message}
                    secondaryMessage={modalMessage.SecondaryMessage}
                    primaryButtonText={null}
                    secondaryButtonText={null}
                    tertiaryButtonText="Cerrar"
                    onTertiaryClick={handleCloseModal}
                    onClose={handleCloseModal}
                />
            </div>
        )
    }

    return isRunning && (
        <>
            {children}
            {<ErrorModal />}
        </>
    );
}

export default AxiosInterceptor;